import _ from 'lodash';
import Emitter from '../../services/emitter';
import Storage from '../../services/api/store';
import CONSTANT from '../../constant';
import ExtensionCloud from '../../services/extension/extension.cloud';
import Api from '../../services/api';
// import Mscratch from '../../services/mscratch';
import { loadExt, unloadExt } from '../../services/mscratch/ext';
import { isForExt } from '../../util/env';

export const LIST = 'LIST';
export const ADD = 'ADD';
export const REMOVE = 'REMOVE';

/**
 * 预加载用户之前加载过的扩展
 *
 * @param {any} exts
 */
const preloadExt = (exts) => {
    const installed = eval(Storage.get(CONSTANT.INSTALLED_EXT)) || [];
    _.isArray(exts) && exts.forEach(async ext => {
        if (installed.indexOf(ext.id.toLowerCase()) !== -1) {
            await loadExt(ext);
        }
    });
};

/**
 * 数据转换
 *
 * @param {any} exts
 */
const translate = (exts) => {
    _.isArray(exts) && exts.forEach(ext => {
        if (_.has(ext, 'targets')) {
            if (_.isString(ext.targets)) {
                ext.targets = [ext.targets.toLowerCase()];
            } else if (_.isArray(ext.targets)) {
                ext.targets = (ext.targets.join('|').toLowerCase()).split('|');
            }
        }
    });
};

// 扩展列表
let extList = [];
// 设备扩展
let deviceExtList = [];

const manifest = (ext) => {
    if (ext.identify) {
        const id = ext.identify || `mblock_ext_${ext.id || ''}`;
        const data = {
            id: id,
            iconURL: _.has(ext.icon, 'url') ? ext.icon.url : ext.icon,
            name: { 'zh': ext.name },
            description: { 'zh': ext.description },
            targets: ext.targets,
            main: ext['main'],
            codeTypes: ext.codeTypes,
            sortId: ext['sort'],
            device: ext.device
        };
        return data;
    }
    return ext;
};

const list = (type = 'common', isPreload = false) => {
    const state = {
        type: LIST,
        payload: {}
    };
    return async dispatch => {
        let exts = [];
        try {
            if (isForExt()) {
                exts = await Api.Extension.getRemoteExts({});
                exts = exts.map((ext) => {
                    return manifest(ext);
                });
            } else {
                if (type === 'common') {
                    exts = await ExtensionCloud.getExtList('ext') || [];
                    exts = exts.map((e) => { return { ...e, installing: false }; });
                    // exts = edata.concat(remoteExts('common')) || [];
                } else if (type === 'devices') {
                    exts = await ExtensionCloud.getExtList('device') || [];
                    // exts = ddata.concat(remoteExts());
                }
            }
        } catch (error) {
            console.warn(error);
            dispatch(state);
            return;
        }
        // 数据转换
        translate(exts);
        // 如果是预加载列表
        if (isPreload) {
            preloadExt(exts);
        }
        if (type === 'common') {
            const tags = _.uniq(((_.map(exts, 'targets')).join('|')).split('|'));
            state.payload.tags = tags;
            state.payload.exts = exts;
        } else {
            state.payload.devices = exts;
        }
        dispatch(state);
    };
};

const onlineList = () => {
    const state = {
        type: LIST,
        payload: {}
    };
    return async dispatch => {
        let exts = [];
        try {
            exts = await ExtensionCloud.getExtList('device');
        } catch (error) {
            console.warn(error);
        }
        // 数据转换
        translate(exts);
        exts = exts.map((ext) => {
            return manifest(ext);
        });
        // console.log(exts);
        state.payload.list = exts;
        dispatch(state);
    };
};

const add = (info, successCb, failCb) => {
    return async (dispatch, getState) => {
        const updateList = (installing) => {
            const exts = getState().extension.exts.map((e) => e.id === info.id ? { ...e, installing } : e);
            dispatch({
                type: ADD,
                payload: { exts }
            });
        };
        updateList(true);
        const isLoaded = await loadExt(info, true);
        if (isLoaded) {
            // 如果添加不是设备
            if (info.device !== true) {
                const installed = eval(Storage.get(CONSTANT.INSTALLED_EXT)) || [];
                if (installed.indexOf(info.id.toLowerCase()) === -1) {
                    installed.push(info.id.toLowerCase());
                }
                Storage.set(CONSTANT.INSTALLED_EXT, installed);
                Emitter.emit('LogExtension', info.id, true);
                dispatch({
                    type: ADD,
                    payload: { installed }
                });
            }
            updateList(false);
            successCb && successCb();
        } else {
            updateList(false);
            failCb && failCb();
        }
    };
};

const remove = (extId, successCb, failCb) => {
    const installed = eval(Storage.get(CONSTANT.INSTALLED_EXT)) || [];
    if (unloadExt(extId) === true) {
        _.remove(installed, id => (id === extId.toLowerCase()));
        Storage.set(CONSTANT.INSTALLED_EXT, installed);
        successCb && successCb();
        Emitter.emit('LogExtension', extId, false);
    } else {
        failCb && failCb();
    }
    return {
        type: REMOVE,
        payload: { installed }
    };
};

const load = async (exts) => {
    if (!_.isEmpty(exts)) {
        let list = [];
        try {
            if (isForExt()) {
                list = await Api.Extension.getRemoteExts({});
                list = list.map((ext) => {
                    return manifest(ext);
                });
            } else {
                if (_.isEmpty(extList)) {
                    list = list.concat(await ExtensionCloud.getExtList('ext'));
                } else {
                    list = list.concat(extList);
                }
                if (_.isEmpty(deviceExtList)) {
                    list = list.concat(await ExtensionCloud.getExtList('device'));
                } else {
                    list = list.concat(deviceExtList);
                }
            }
        } catch (error) {
            console.log(error);
        }
        list.forEach((item) => {
            // const installed = eval(Storage.get(CONSTANT.INSTALLED_EXT)) || [];
            if (exts.indexOf(item.id.toLowerCase()) >= 0 || exts.indexOf(item.id) >= 0) {
                loadExt(item);
            }
        });
    }
};


export default {
    list,
    onlineList,
    add,
    remove,
    load
};
